import theme from '../theme';
import { getMixedColor } from './colorUtils';

const colors = [
  theme.color.secondary1,
  theme.color.secondary2,
  theme.color.secondary3,
  theme.color.secondary4
];

export default function getGlobalLeaderboardColor(i, length) {
  return getMixedColor(colors, i / (length - 1));
}
